import React from 'react';
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import moment from 'moment-timezone';
import Spinner from "../../common/spinner";
import SectionLoadingError from "../../common/SectionLoadingError";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";

class ChooseATime extends React.Component {
    constructor() {
        super();
        this.state = {
            day: 0,
            daySlot: null,
            selectedTimeSlot: null,
            isTimeSelectionError : false
        };
    }

    componentDidMount() {
        const { showTimeZoneMessage } = this.props;
        const date = showTimeZoneMessage && !Tools.isCentralTimeZone() ? moment(Tools.getCurDateInCentralTz()).format("MM/DD/YYYY") : Tools.getFormattedDate(new Date());
        const clientUTCOffset = showTimeZoneMessage && !Tools.isCentralTimeZone() ? moment(Tools.getCurDateInCentralTz()).utcOffset() : moment().utcOffset();
        this.props.getVideoVisitTimeSlots(clientUTCOffset, date); 
        logUI("MBHWeb.UI.VideoVisit.ChooseATime.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState) {
        const { isWaiting, timeslots } = this.props.videoVisitTimeSlots;
        if (timeslots && prevProps.videoVisitTimeSlots && prevProps.videoVisitTimeSlots.isWaiting === true && !isWaiting) {
            const data = timeslots; 
            if (data && data.length > 0)
                this.setState({
                    data,
                    daySlot: data[0].morning.length > 0 ? "morning"
                        : data[0].afternoon.length > 0 ? "afternoon"
                            : data[0].evening.length > 0 ? "evening"
                                : null
                });
        }
        logUI("MBHWeb.UI.VideoVisit.ChooseATime.ComponentDidUpdate", new Date(), Tools.getURLPath());
    }
   
    onTimeSelectionChange = (timeSlot) => {
        this.setState({
            selectedTimeSlot: timeSlot,
            isTimeSelectionError: false
        });

    }

    onDayChange = (day) => {
        const { data } = this.state;
        this.setState({
            day,
            daySlot: data[day].morning.length > 0 ? "morning"
                : data[day].afternoon.length > 0 ? "afternoon"
                    : data[day].evening.length > 0 ? "evening"
                        : null,
            selectedTimeSlot : null
        });        
        logUI("MBHWeb.UI.VideoVisit.ChooseATime.DaySelection", new Date(), Tools.getURLPath());
    }

    onContinueClick = () => {
        const { selectedTimeSlot, day } = this.state;
        if (selectedTimeSlot) {
            this.props.onTimeSelectionChange(selectedTimeSlot, day);
            this.props.goNext();
        }
        else {
            this.setState({
                isTimeSelectionError: true
            })
        }
        logUI("MBHWeb.UI.VideoVisit.ChooseATime.ContinueClick", new Date(), Tools.getURLPath());
    }

    isValid() {
        const { selectedTimeSlot } = this.state;
        return selectedTimeSlot !== null;
    }
    //onRetry = () => {
    //    this.props.goBack(0);   //Waiting for confirmation.
    //}
    render() {
        const { daySlot, day, selectedTimeSlot, data, isTimeSelectionError } = this.state;
        const { showTimeZoneMessage } = this.props;
        const timezone = showTimeZoneMessage && !Tools.isCentralTimeZone() ? this.props.timezone : Tools.getTimeZone();
        const dayLabel = data && data.length > 0 ? showTimeZoneMessage && !Tools.isCentralTimeZone() ? moment(data[day].dateInDallas).format("ddd. MMM D") : data[day].dateLabel : "";
        var timesUIelements = data && daySlot && data[day][daySlot].map((item, index) => {
            let isbuttonActive = showTimeZoneMessage ? selectedTimeSlot != null && selectedTimeSlot.dateTimeInDallas === item.dateTimeInDallas : selectedTimeSlot != null && selectedTimeSlot.dateTimeInUtc === item.dateTimeInUtc;
            return <button key={index} type="button"
                className={`btn btn-primary ${(isbuttonActive) ? 'active ' : ''}`}
                onClick={() => this.onTimeSelectionChange(item)}>
                {showTimeZoneMessage ? moment(item.dateTimeInDallas).format("h:mm A") : moment.utc(item.dateTimeInUtc).local().format("h:mm A")}
            </button>
        });
        const { timeslots, isWaiting, isSuccess, isError } = this.props.videoVisitTimeSlots;

        return (
            <div className="choose-a-time-container sm-width-step" style={this.props.style}>
                {typeof timeslots === 'undefined' || isWaiting && !isSuccess
                    ? <Spinner />
                    : <div className="row">
                        <div className="col-12">
                            {!isError && data && data.length > 0
                                ? <div className="row">
                                    <div className="col-12">
                                        <h1 className="step-heading step-heading-md">When would you like {!this.props.enabledVirtualDashboard && 'to schedule '}this appointment?</h1>
                                    </div>
                                    <div className="col-12 step-form-container">
                                        <div className="row">
                                            <div className="col-12 select-day">
                                                <div className="separator" />
                                                <div className="back-arrow"><span className={`icon-arrow-rt ${day === 0 ? "btn-disabled" : ""}`} onClick={e => day === 0 ? null : this.onDayChange(day - 1)} /></div>
                                                {dayLabel}
                                                <div className="icon-end"><span className={`icon-arrow-rt ${day === data.length - 1 ? "btn-disabled" : ""}`} onClick={e => day === data.length - 1 ? null : this.onDayChange(day + 1)} /></div>
                                                <div className="separator" />
                                            </div>
                                            <div className="col-12">
                                                <div className="row day-time-btns">
                                                    {["morning", "afternoon", "evening"].map((slot, index) => {
                                                        return (<button
                                                            key={`daySlot-${index}`}
                                                            type="button"
                                                            className={`btn btn-primary col ${daySlot === slot ? 'active' : ''} ${data[day][slot].length === 0 ? 'disabled' : ''}`}
                                                            onClick={() => data[day][slot].length === 0 ? null : this.setState({ daySlot: slot, selectedTimeSlot: null })}
                                                        >{slot}</button>);
                                                    })}
                                                </div>
                                            </div>
                                            <div className="col-12 text-margin">
                                                All times are in {timezone} time zone.
                                            </div>
                                            <div className="col-12 select-time">
                                                <div className="select-time-slots">
                                                    {timesUIelements}
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="yellow-banner">
                                                    If this is an emergency, please contact 911.
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="footer-buttons">
                                                    {isTimeSelectionError &&
                                                        <div className="error-msg">Please select an available time.</div>
                                                    }
                                                    <button type="button" className={`btn btn-primary`} onClick={() => this.onContinueClick()}>CONTINUE</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : <>
                                    <SectionLoadingError message="We are not able to display appointment times. Please try again later." />
                                    {/* <div className="col-12 try-again">Please <input type="submit" className="btn text-btn" value="try again" onClick={() => this.onRetry()} />.</div> */}
                                </>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        videoVisitTimeSlots: state.videoVisitScheduling.videoVisitTimeSlots ? state.videoVisitScheduling.videoVisitTimeSlots : {}
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getVideoVisitTimeSlots: (clientUTCOffset, date) => dispatch({ type: types.GET_VIDEO_VISIT_TIME_SLOTS, data: { clientUTCOffset, date } })
    };
};
export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ChooseATime);